export default "/images/reports.svg?e2c5865d21b887c87d00b62fa73c6a84";